export default {
  api: [
    {
      name: 'replaceOpen',
      method: 'POST',
      desc: '代客开户',
      path: 'account/open'
    },
    {
      name: 'replaceInfo',
      method: 'GET',
      desc: '代客开户-获取基本信息',
      path: 'account/info'
    },
    {
      name: 'orgList',
      method: 'GET',
      desc: '选择企业列表',
      path: 'org/list'
    },
    {
      name: 'hasOpens',
      method: 'GET',
      desc: '下拉列表 - 是否已开通账户',
      path: 'dropdown/hasOpens'
    },
    {
      name: 'traStatus',
      method: 'GET',
      desc: '交易状态列表',
      path: 'tra/traStatus'
    }
  ],
  BASE_URL: '/ccb/pay'
}



// WEBPACK FOOTER //
// ./src/api/apis/fund/index.js